import { useRecarregarAoAtivar } from "../../hooks/useRecarregarAoAtivar";
import { useSolicitacoesTerceiros } from "../../hooks/useSolicitacoesTerceiros";
import { Filtros } from "../Filtros";
import { Listar } from "../Listar";

interface IProps {
  ativa: boolean;
  onLoteEnviado: () => void;
}

export function Solicitacoes({ ativa, onLoteEnviado }: IProps) {
  const {
    solicitacoes,
    totalRegistros,
    carregando,
    limite,
    reiniciarPaginacao,
    aplicarFiltros,
    setPagina,
    mudarLimite,
    ordenar,
    recarregar,
    exportar,
    exportando,
    enviar,
    enviando,
  } = useSolicitacoesTerceiros();

  useRecarregarAoAtivar(ativa, recarregar);

  return (
    <>
      <Filtros onBuscar={aplicarFiltros} />
      <Listar
        ativa={ativa}
        solicitacoes={solicitacoes}
        totalRegistros={totalRegistros}
        carregando={carregando}
        limite={limite}
        reiniciarPaginacao={reiniciarPaginacao}
        onMudarPagina={setPagina}
        onMudarLimite={mudarLimite}
        onOrdenar={ordenar}
        onExportar={exportar}
        exportando={exportando}
        onEnviar={enviar}
        enviando={enviando}
        onLoteEnviado={onLoteEnviado}
        onMovidas={() => {
          recarregar();
          onLoteEnviado();
        }}
      />
    </>
  );
}
